import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '../database/firebase';
import { useAuth } from '../context/AuthContext';

const TeamMemberProtectedRoute = ({ children }) => {
  const { currentUser, loading: authLoading } = useAuth();
  const [isTeamMember, setIsTeamMember] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkTeamMemberStatus = async () => {
      if (!currentUser) {
        setLoading(false);
        return;
      }

      try {
        const teamMemberDoc = await getDoc(doc(firestore, 'teamMembers', currentUser.uid));
        setIsTeamMember(teamMemberDoc.exists());
      } catch (error) {
        setIsTeamMember(false);
      } finally {
        setLoading(false);
      }
    };

    if (!authLoading) {
      checkTeamMemberStatus();
    }
  }, [currentUser, authLoading]);

  if (authLoading || loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="h-12 w-12 animate-spin rounded-full border-4 border-blue-500 border-t-transparent"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/team-login" state={{ from: location }} replace />;
  }

  if (!isTeamMember) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="mb-4 inline-block rounded-full bg-red-100 p-4">
            <svg
              className="h-8 w-8 text-red-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
          <h2 className="mb-2 text-2xl font-bold text-gray-800">Access Denied</h2>
          <p className="mb-4 text-gray-600">
            You don't have permission to access the team dashboard.
          </p>
          <button
            onClick={() => (window.location.href = '/team-login')}
            className="rounded-md bg-blue-500 px-4 py-2 text-white transition-colors hover:bg-blue-600"
          >
            Go to Team Login
          </button>
        </div>
      </div>
    );
  }

  return children;
};

export default TeamMemberProtectedRoute;
